/**
 * commerce translations
 * Auto-split from staticTranslations.ts
 */

// ─── Product Card ─────────────────────────────────────────
export const productCard = {
  en: {
    addToCart: "Add to Cart",
  },
  ru: {
    addToCart: "В корзину",
  },
  ar: {
    addToCart: "أضف إلى السلة",
  },
};

// ─── Cart Drawer ─────────────────────────────────────────
export const cartDrawer = {
  en: {
    triggerLabel: "Shopping Cart",
  },
  ru: {
    triggerLabel: "Корзина",
  },
  ar: {
    triggerLabel: "سلة التسوق",
  },
};

// ─── Search Dialog ─────────────────────────────────────────
export const search = {
  en: {
    triggerLabel: "Search products",
    title: "Product Search",
    placeholder: "Search jewelry by name...",
    voiceStop: "Stop recording",
    voiceStart: "Voice search",
    imageSearch: "Search by image",
    smartFilter: "Smart filter",
    visualSearchAdvanced: "Advanced visual search:",
    imageSearchLabel: "Image search:",
    results: "results",
    priceRange: "Price Range",
    category: "Category",
    all: "All",
    clearFilter: "Clear filter",
    searching: "Searching...",
    sitePages: "Site Pages",
    categories: "Categories",
    foundProducts: (count: number) => count === 1 ? "Found 1 product" : `Found ${count} products`,
    pages: "pages",
    categoriesCount: "categories",
    filtered: "(filtered)",
    foundFor: "for",
    relatedProducts: "Related products you might like",
    noExactResults: "No exact results found for",
    butWeHaveRelated: "but we have related products",
    forTerm: "for",
    noResults: "No results found for",
    tryDifferent: "Try a different search term",
    tryClearFilter: "Try clearing the filter",
    couldNotLoad: "Couldn't load products right now",
    startTyping: "Start typing to search products",
    similarPercent: "similar",
  },
  ru: {
    triggerLabel: "Поиск товаров",
    title: "Поиск товаров",
    placeholder: "Искать украшения по названию...",
    voiceStop: "Остановить запись",
    voiceStart: "Голосовой поиск",
    imageSearch: "Поиск по изображению",
    smartFilter: "Умный фильтр",
    visualSearchAdvanced: "Расширенный визуальный поиск:",
    imageSearchLabel: "Поиск по изображению:",
    results: "результатов",
    priceRange: "Диапазон цен",
    category: "Категория",
    all: "Все",
    clearFilter: "Очистить фильтр",
    searching: "Поиск...",
    sitePages: "Страницы сайта",
    categories: "Категории",
    foundProducts: (count: number) => count === 1 ? "Найден 1 товар" : `Найдено ${count} товаров`,
    pages: "страниц",
    categoriesCount: "категорий",
    filtered: "(отфильтровано)",
    foundFor: "по запросу",
    relatedProducts: "Похожие товары, которые могут вас заинтересовать",
    noExactResults: "Точных результатов не найдено для",
    butWeHaveRelated: "но у нас есть похожие товары",
    forTerm: "для",
    noResults: "Ничего не найдено для",
    tryDifferent: "Попробуйте другой запрос",
    tryClearFilter: "Попробуйте очистить фильтр",
    couldNotLoad: "Не удалось загрузить товары",
    startTyping: "Начните вводить для поиска товаров",
    similarPercent: "сходство",
  },
  ar: {
    triggerLabel: "البحث عن منتجات",
    title: "البحث عن منتجات",
    placeholder: "ابحث عن مجوهرات بالاسم...",
    voiceStop: "إيقاف التسجيل",
    voiceStart: "بحث صوتي",
    imageSearch: "بحث بالصورة",
    smartFilter: "فلتر ذكي",
    visualSearchAdvanced: "بحث مرئي متقدم:",
    imageSearchLabel: "بحث بالصورة:",
    results: "نتائج",
    priceRange: "نطاق السعر",
    category: "الفئة",
    all: "الكل",
    clearFilter: "مسح الفلتر",
    searching: "جاري البحث...",
    sitePages: "صفحات الموقع",
    categories: "الفئات",
    foundProducts: (count: number) => count === 1 ? "تم العثور على منتج واحد" : `تم العثور على ${count} منتجات`,
    pages: "صفحات",
    categoriesCount: "فئات",
    filtered: "(مُفلتر)",
    foundFor: "لـ",
    relatedProducts: "منتجات ذات صلة قد تعجبك",
    noExactResults: "لم يتم العثور على نتائج دقيقة لـ",
    butWeHaveRelated: "لكن لدينا منتجات ذات صلة",
    forTerm: "لـ",
    noResults: "لم يتم العثور على نتائج لـ",
    tryDifferent: "جرب كلمة بحث مختلفة",
    tryClearFilter: "جرب مسح الفلتر",
    couldNotLoad: "لم نتمكن من تحميل المنتجات حالياً",
    startTyping: "ابدأ بالكتابة للبحث عن منتجات",
    similarPercent: "تشابه",
  },
};

// ─── Variant Quick Picker ─────────────────────────────────────────
export const variantPicker = {
  en: {
    variantUnavailable: "Variant unavailable", noEngraving: "Without engraving",
    productDescription: "Product Description", outOfStock: "Out of Stock", addToCart: "Add to Cart",
    engravingError: "Please fill in engraving details", engravingErrorDesc: "Select a font and enter engraving text",
  },
  ru: {
    variantUnavailable: "Вариант недоступен", noEngraving: "Без гравировки",
    productDescription: "Описание товара", outOfStock: "Нет в наличии", addToCart: "В корзину",
    engravingError: "Заполните данные гравировки", engravingErrorDesc: "Выберите шрифт и введите текст",
  },
  ar: {
    variantUnavailable: "الخيار غير متاح", noEngraving: "بدون نقش",
    productDescription: "وصف المنتج", outOfStock: "نفذ من المخزون", addToCart: "أضف إلى السلة",
    engravingError: "يرجى ملء تفاصيل النقش", engravingErrorDesc: "اختر خطاً وأدخل نص النقش",
  },
};

// ─── Engraving Options ─────────────────────────────────────
export const engraving = {
  en: {
    title: "Personal Engraving",
    subtitle: "Add a personal touch to your jewellery",
    multipleLocations: "engraving locations available",
    selectFont: "Select font style",
    required: "*",
    recommendation: "Recommendation:",
    rec2: "You can engrave up to 3 words per field. Example: Field 1 - \"I love you\", Field 2 - \"Forever yours\"",
    rec3: "You can engrave up to 3 words per field. Example: one word per field, or a short sentence in one field",
    rec4: "You can engrave up to 3 words per field. Example: name in field 1, date in field 2, short message in other fields",
    rec5: "You can engrave up to 3 words in each of the fields. Recommended to split the message between fields",
    engravingText: "Engraving text",
    engravingTextNum: "Engraving text",
    words: "words",
    example1: "e.g.: I love you",
    example2a: "e.g.: I love you",
    example2b: "e.g.: Forever yours",
    example3a: "e.g.: Love",
    example3b: "e.g.: Forever",
    example3c: "e.g.: Ours",
    example4a: "e.g.: Name",
    example4b: "e.g.: Date",
    example4c: "e.g.: Love",
    example4d: "e.g.: Forever",
    exampleDefault: "e.g.: Text",
    upTo3Words: "(up to 3 words)",
    optional: "- optional",
    infoMultiple: "The texts will be engraved on the jewellery in different locations in the style you chose",
    infoSingle: "The text will be engraved on the jewellery in the style you chose",
    selectFontError: "Please select a font",
    enterTextError: "Please enter engraving text",
  },
  ru: {
    title: "Личная гравировка",
    subtitle: "Добавьте личный штрих к вашему украшению",
    multipleLocations: "мест для гравировки доступно",
    selectFont: "Выберите стиль шрифта",
    required: "*",
    recommendation: "Рекомендация:",
    rec2: "Можно выгравировать до 3 слов в каждом поле. Например: поле 1 — «Я люблю тебя», поле 2 — «Навсегда твоя»",
    rec3: "Можно выгравировать до 3 слов в каждом поле. Например: одно слово в каждом поле или короткую фразу",
    rec4: "Можно выгравировать до 3 слов в каждом поле. Например: имя в поле 1, дату в поле 2, сообщение в остальных",
    rec5: "Можно выгравировать до 3 слов в каждом из полей. Рекомендуется разделить послание между полями",
    engravingText: "Текст гравировки",
    engravingTextNum: "Текст гравировки",
    words: "слов",
    example1: "напр.: Я люблю тебя",
    example2a: "напр.: Я люблю тебя",
    example2b: "напр.: Навсегда твоя",
    example3a: "напр.: Любовь",
    example3b: "напр.: Навсегда",
    example3c: "напр.: Наша",
    example4a: "напр.: Имя",
    example4b: "напр.: Дата",
    example4c: "напр.: Любовь",
    example4d: "напр.: Навсегда",
    exampleDefault: "напр.: Текст",
    upTo3Words: "(до 3 слов)",
    optional: "— необязательно",
    infoMultiple: "Тексты будут выгравированы на украшении в разных местах в выбранном стиле",
    infoSingle: "Текст будет выгравирован на украшении в выбранном стиле",
    selectFontError: "Выберите шрифт",
    enterTextError: "Введите текст для гравировки",
  },
  ar: {
    title: "نقش شخصي",
    subtitle: "أضف لمسة شخصية إلى مجوهراتك",
    multipleLocations: "مواقع نقش متاحة",
    selectFont: "اختر نمط الخط",
    required: "*",
    recommendation: "توصية:",
    rec2: "يمكن نقش حتى 3 كلمات في كل حقل. مثال: حقل 1 — «أحبك»، حقل 2 — «إلى الأبد»",
    rec3: "يمكن نقش حتى 3 كلمات في كل حقل. مثال: كلمة واحدة في كل حقل أو جملة قصيرة",
    rec4: "يمكن نقش حتى 3 كلمات في كل حقل. مثال: الاسم في حقل 1، التاريخ في حقل 2",
    rec5: "يمكن نقش حتى 3 كلمات في كل حقل. يُنصح بتقسيم الرسالة بين الحقول",
    engravingText: "نص النقش",
    engravingTextNum: "نص النقش",
    words: "كلمات",
    example1: "مثال: أحبك",
    example2a: "مثال: أحبك",
    example2b: "مثال: إلى الأبد",
    example3a: "مثال: حب",
    example3b: "مثال: أبداً",
    example3c: "مثال: لنا",
    example4a: "مثال: الاسم",
    example4b: "مثال: التاريخ",
    example4c: "مثال: حب",
    example4d: "مثال: أبداً",
    exampleDefault: "مثال: نص",
    upTo3Words: "(حتى 3 كلمات)",
    optional: "— اختياري",
    infoMultiple: "ستُنقش النصوص على المجوهرات في مواقع مختلفة بالنمط الذي اخترته",
    infoSingle: "سيُنقش النص على المجوهرات بالنمط الذي اخترته",
    selectFontError: "يرجى اختيار خط",
    enterTextError: "يرجى إدخال نص للنقش",
  },
};

// ─── Try On Dialog ─────────────────────────────────────────
export const tryOn = {
  en: {
    title: "Try On —",
    before: "Before",
    after: "After",
    tryAgain: "Try Again",
    download: "Download",
    addToCart: "Add to Cart",
    close: "Close",
    processing: "Processing...",
    starting: "Starting...",
    step1: "Analyzing the image...",
    step2: "Detecting body area...",
    step3: "Fitting the jewelry...",
    step4: "Processing details...",
    step5: "Almost ready...",
    ready: "Ready!",
    processTime: "The process may take up to a minute",
    uploadPrompt: "Upload a clear photo of yourself — frontal, good lighting, and the relevant area (neck/ears/hands) visible.",
    yourImage: "Your photo",
    tryOnMe: "Try on me",
    upload: "Upload",
    capture: "Capture",
    imagesNotSaved: "Images are not saved or collected — single use only.",
    imageError: "Error processing the image",
    cameraError: "Cannot access the camera. Please enable access in your browser settings.",
    flipCamera: "Flip camera",
    cancel: "Cancel",
    errorCreating: "Error creating the image",
    switchCameraError: "Cannot switch camera.",
  },
  ru: {
    title: "Примерить —",
    before: "До",
    after: "После",
    tryAgain: "Попробовать снова",
    download: "Скачать",
    addToCart: "В корзину",
    close: "Закрыть",
    processing: "Обработка...",
    starting: "Начинаем...",
    step1: "Анализируем изображение...",
    step2: "Определяем область тела...",
    step3: "Примеряем украшение...",
    step4: "Обрабатываем детали...",
    step5: "Почти готово...",
    ready: "Готово!",
    processTime: "Процесс может занять до минуты",
    uploadPrompt: "Загрузите чёткое фото — фронтальное, с хорошим освещением, область (шея/уши/руки) открыта.",
    yourImage: "Ваше фото",
    tryOnMe: "Примерить",
    upload: "Загрузить",
    capture: "Сфотографировать",
    imagesNotSaved: "Изображения не сохраняются — одноразовое использование.",
    imageError: "Ошибка обработки изображения",
    cameraError: "Не удаётся получить доступ к камере. Разрешите доступ в настройках браузера.",
    flipCamera: "Переключить камеру",
    cancel: "Отмена",
    errorCreating: "Ошибка при создании изображения",
    switchCameraError: "Не удаётся переключить камеру.",
  },
  ar: {
    title: "جرّب —",
    before: "قبل",
    after: "بعد",
    tryAgain: "حاول مرة أخرى",
    download: "تحميل",
    addToCart: "أضف إلى السلة",
    close: "إغلاق",
    processing: "جاري المعالجة...",
    starting: "جاري البدء...",
    step1: "تحليل الصورة...",
    step2: "تحديد منطقة الجسم...",
    step3: "تجربة المجوهرات...",
    step4: "معالجة التفاصيل...",
    step5: "تقريباً جاهز...",
    ready: "جاهز!",
    processTime: "قد تستغرق العملية حتى دقيقة",
    uploadPrompt: "ارفع صورة واضحة لك — أمامية، إضاءة جيدة، والمنطقة المعنية (رقبة/أذنين/يدين) ظاهرة.",
    yourImage: "صورتك",
    tryOnMe: "جرّب عليّ",
    upload: "رفع",
    capture: "تصوير",
    imagesNotSaved: "الصور لا تُحفظ ولا تُجمع — استخدام لمرة واحدة فقط.",
    imageError: "خطأ في معالجة الصورة",
    cameraError: "لا يمكن الوصول إلى الكاميرا. يرجى السماح بالوصول في إعدادات المتصفح.",
    flipCamera: "قلب الكاميرا",
    cancel: "إلغاء",
    errorCreating: "خطأ في إنشاء الصورة",
    switchCameraError: "لا يمكن تبديل الكاميرا.",
  },
};

// ─── Image Search Uploader ─────────────────────────────────
export const imageSearch = {
  en: {
    cameraError: "Cannot access the camera. Please enable access in your browser settings.",
    switchCameraError: "Cannot switch camera.",
    flipCamera: "Flip camera",
    cancel: "Cancel",
    capture: "Capture",
    preparing: "Preparing image...",
    identifyingType: "Identifying jewellery type...",
    searchingProducts: "Searching matching products...",
    loadingImages: "Loading product images...",
    comparingImages: "Comparing images...",
    rankingSimilarity: "Ranking by similarity...",
    finishing: "Finishing...",
    done: "Done...",
    systemBusy: "The system is busy. Try again in a few minutes.",
    serviceError: "There is a problem with the service. Try again later.",
    analyzeError: "Error analyzing the image",
    foundProducts: "similar products found!",
    identified: "Identified:",
    error: "Error",
    processingImage: "Processing image...",
    imageProcessError: "Error processing the image, try a different image",
    unsupportedFile: "Unsupported file",
    uploadImageFile: "Please upload an image file",
    searchImage: "Image for search",
    visualSearchTime: "Visual search may take up to a minute",
    dragImageHere: "Drag an image here",
    orClickToSelect: "or click to select a file from your device",
    advancedVisualSearch: "Advanced visual search — finds similar products by image",
    takePhoto: "Take a photo",
  },
  ru: {
    cameraError: "Не удаётся получить доступ к камере. Разрешите доступ в настройках браузера.",
    switchCameraError: "Не удаётся переключить камеру.",
    flipCamera: "Переключить камеру",
    cancel: "Отмена",
    capture: "Сфотографировать",
    preparing: "Подготовка изображения...",
    identifyingType: "Определение типа украшения...",
    searchingProducts: "Поиск подходящих товаров...",
    loadingImages: "Загрузка изображений товаров...",
    comparingImages: "Сравнение изображений...",
    rankingSimilarity: "Ранжирование по сходству...",
    finishing: "Завершаем...",
    done: "Готово...",
    systemBusy: "Система загружена. Попробуйте через несколько минут.",
    serviceError: "Проблема с сервисом. Попробуйте позже.",
    analyzeError: "Ошибка анализа изображения",
    foundProducts: "похожих товаров найдено!",
    identified: "Определено:",
    error: "Ошибка",
    processingImage: "Обработка изображения...",
    imageProcessError: "Ошибка обработки изображения, попробуйте другое",
    unsupportedFile: "Неподдерживаемый файл",
    uploadImageFile: "Загрузите файл изображения",
    searchImage: "Изображение для поиска",
    visualSearchTime: "Визуальный поиск может занять до минуты",
    dragImageHere: "Перетащите изображение сюда",
    orClickToSelect: "или нажмите для выбора файла",
    advancedVisualSearch: "Продвинутый визуальный поиск — находит похожие товары по фото",
    takePhoto: "Сделать фото",
  },
  ar: {
    cameraError: "لا يمكن الوصول إلى الكاميرا. يرجى السماح بالوصول في إعدادات المتصفح.",
    switchCameraError: "لا يمكن تبديل الكاميرا.",
    flipCamera: "قلب الكاميرا",
    cancel: "إلغاء",
    capture: "تصوير",
    preparing: "تحضير الصورة...",
    identifyingType: "تحديد نوع المجوهرات...",
    searchingProducts: "البحث عن منتجات مطابقة...",
    loadingImages: "تحميل صور المنتجات...",
    comparingImages: "مقارنة الصور...",
    rankingSimilarity: "ترتيب حسب التشابه...",
    finishing: "جاري الانتهاء...",
    done: "تم...",
    systemBusy: "النظام مشغول. حاول مرة أخرى بعد بضع دقائق.",
    serviceError: "هناك مشكلة في الخدمة. حاول لاحقاً.",
    analyzeError: "خطأ في تحليل الصورة",
    foundProducts: "منتجات مشابهة!",
    identified: "تم التعرف:",
    error: "خطأ",
    processingImage: "معالجة الصورة...",
    imageProcessError: "خطأ في معالجة الصورة، جرب صورة أخرى",
    unsupportedFile: "ملف غير مدعوم",
    uploadImageFile: "يرجى رفع ملف صورة",
    searchImage: "صورة للبحث",
    visualSearchTime: "البحث البصري قد يستغرق حتى دقيقة",
    dragImageHere: "اسحب صورة إلى هنا",
    orClickToSelect: "أو انقر لاختيار ملف من جهازك",
    advancedVisualSearch: "بحث بصري متقدم — يجد منتجات مشابهة حسب الصورة",
    takePhoto: "التقط صورة",
  },
};
